import { OauthService } from './oauth.service';
import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector
} from '@angular/core';
import { Http } from '@angular/http';
import { App, LoadingController } from 'ionic-angular';
import { ToolsService } from './tools.service';
import { ReduccePaymentLoaderComponent } from '../../core/reducce-payment-loader/reducce-payment-loader.component';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ReduccePaymentService extends OauthService {

  public componentRef: ComponentRef<any>;

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private loadingCtrl: LoadingController
      ) {
    super(http, app, appProvider, tools);
  }

  presentLoader(orderId: number, beneficiaireId: number, paymentStatus: string, isWorkflow: boolean, isSubvention: boolean, onlyPopupInfo?: boolean) {

    //create a component reference
    this.componentRef = this.componentFactoryResolver.resolveComponentFactory(ReduccePaymentLoaderComponent).create(this.injector);

    this.componentRef.instance.orderId = orderId;
    this.componentRef.instance.beneficiaireId = beneficiaireId;
    this.componentRef.instance.paymentStatus = paymentStatus;
    this.componentRef.instance.isWorkflow = isWorkflow;
    this.componentRef.instance.isSubvention = isSubvention;
    this.componentRef.instance.onlyPopupInfo = onlyPopupInfo;
    this.componentRef.instance.closeEmitter.subscribe(res => {
        this.removeLoader();
        if (!onlyPopupInfo) {
          if (isWorkflow) {
            // Cas dans le processus de paiement
            this.app.getRootNav().setRoot('OrderPage', {
              'order': orderId,
              'beneficiaire': beneficiaireId,
              'paymentStatus': paymentStatus
            });
          } else {
            // Accès à la page détail de commande hors processus de paiement
            this.app.getActiveNav().push('OrderPage', {order: orderId, beneficiaire: beneficiaireId});
          }
        }
    });

    // attach component to the appRef so that so that it will be dirty checked.
    this.applicationRef.attachView(this.componentRef.hostView);

    // get DOM element from component
    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.getElementById('app').appendChild(domElem);

    this.applicationRef.tick();
  }

  removeLoader() {
    this.applicationRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
  }


}



// WEBPACK FOOTER //
// ./src/shared/services/reducce-payment.service.ts